import { useRouterState } from '@tanstack/react-router'

export const useCurrentRouteId = () => {
  const routerState = useRouterState()
  return routerState.matches.slice(-1).pop()?.routeId
}
